import {IWorkflowStepBase} from "./workflow-step-base.model";
import {WorkflowStep} from "../../enums/WorkflowStep";
import {IWorkflowStepValidation} from "./workflow-step-validation.model";
import {PlateModel} from "../Plate/plate.model";
import {BatchModel} from "../batch/batch.model";
import {CyclerRunThroughModel} from "../cycler-run-trough/cycler-run-through.model";
import {WorkflowInstanceModel} from "../workflow/workflow-instance.model";
import {Workflow} from "../../enums/Workflow";
import { BatchType } from 'src/app/enums/BatchType';

export class WorkflowStepIndexPcrSetupModel implements IWorkflowStepBase, IWorkflowStepValidation {
  id: number;
  step: WorkflowStep;
  workflowInstance: WorkflowInstanceModel;
  isSkipped: boolean;

  shareToLibrary: boolean;
  plates: PlateModel[];
  batches: BatchModel[];
  cyclerRunThroughs: CyclerRunThroughModel[];

  constructor(id: number, step: WorkflowStep, workflowInstance: WorkflowInstanceModel, plates: PlateModel[], batches: BatchModel[], cyclerRunThroughs: CyclerRunThroughModel[], isSkipped: boolean) {
    this.id = id;
    this.step = step;
    this.workflowInstance = workflowInstance;
    this.isSkipped = isSkipped;
    this.plates = plates.map(PlateModel.fromData);
    this.batches = batches.map(BatchModel.fromData);
    this.cyclerRunThroughs = cyclerRunThroughs;
  }

  isValid(): boolean {
    // valid if a plate exists and all batches are selected
    if (this.batches?.filter(batch => batch.id).length !== BatchType.getAllForIndexPcr().length) {
      return false;
    }

    // check plate and cycler run through counter
    if (this.workflowInstance.workflow === Workflow.WORKFLOW_96) {
      return this.plates.length === 1 && this.plates.every(plate => plate?.id != null && plate?.uploadedFile != null);
    } else {
      return this.plates.length === 4 && this.plates.every(plate => plate?.id != null && plate?.uploadedFile != null);
    }
  }

}
